<template>
    <div class="pend-warning">
        <mc-operate-bar>
            <template slot="left">
                <mc-search-bar v-model="searchParmas" search-label="输入站点名称或告警内容" :search-submit="$_getTableList"></mc-search-bar>
            </template>
        </mc-operate-bar>
        <mc-table ref="mc-table" :table-option="tableOption" v-loading="tableOption.loading">
            <template slot="table-components">
                <el-table-column :prop="tableOption.head[0].prop" :label="tableOption.head[0].label" :width="tableOption.head[0].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        {{$_handleTime(scope.row.occure_at)}}
                    </template>
                </el-table-column>
                <el-table-column :prop="tableOption.head[1].prop" :label="tableOption.head[1].label" :width="tableOption.head[1].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        <span class="deal-item" @click="dialog.siteName.methods.open(scope.row)">{{scope.row.site_name}}</span>
                    </template>
                </el-table-column>
                <el-table-column :prop="tableOption.head[2].prop" :label="tableOption.head[2].label" :width="tableOption.head[2].width"
                    v-if="tableOption.head.length>0"></el-table-column>
                <el-table-column :prop="tableOption.head[3].prop" :label="tableOption.head[3].label" :width="tableOption.head[3].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        <span v-if="scope.row.severity == 0"></span>
                        <span v-else-if="scope.row.severity == 1">正常</span>
                        <span v-else-if="scope.row.severity == 2">一般</span>
                        <span v-else-if="scope.row.severity == 3">紧急</span>
                        <span v-else-if="scope.row.severity == 4">严重</span>
                    </template>
                </el-table-column>
                <el-table-column :prop="tableOption.head[4].prop" :label="tableOption.head[4].label" :width="tableOption.head[4].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        <span v-if="scope.row.worksheet_status == 0"></span>
                        <span class="deal-item" v-else-if="scope.row.worksheet_status == 2" @click="$_creatNewWork(scope.row)">处理</span>
                    </template>
                </el-table-column>
                <el-table-column :prop="tableOption.head[5].prop" :label="tableOption.head[5].label" :width="tableOption.head[5].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        <span @click="dialog.warning.methods.open(scope.row)" class="deal-item content">{{scope.row.content}}</span>
                    </template>
                </el-table-column>
            </template>
        </mc-table>

        <mc-dialog :dialog-option.sync="dialog.siteName">
            <template slot="content">
                <mc-layout-row label-text="站点名称" :labelWidth="120">
                    <mc-label info>{{site.site_name}}</mc-label>
                </mc-layout-row>
                <mc-layout-row label-text="省" :labelWidth="120">
                    <mc-label info>{{site.province}}</mc-label>
                </mc-layout-row>
                <mc-layout-row label-text="市" :labelWidth="120">
                    <mc-label info>{{site.city}}</mc-label>
                </mc-layout-row>
                <mc-layout-row label-text="地址" :labelWidth="120">
                    <mc-label info>{{site.address}}</mc-label>
                </mc-layout-row>
            </template>
        </mc-dialog>

        <mc-dialog :dialog-option.sync="dialog.warning">
            <template slot="content">
                <mc-label info>{{this.dialog.warning.data.content}}</mc-label>
            </template>
        </mc-dialog>

        <mc-dialog :dialog-option.sync="dialog.create">
            <template slot="content">
                <mc-label icon="el-icon-warning" warn>工单已存在，是否创建工单?</mc-label>
            </template>
        </mc-dialog>
    </div>
</template>

<script>
    export default {
        name: "pend-warning",
        data() {
            return {
                searchParmas: '',
                site: [],
                tableOption: {
                    loading: false,
                    index: {
                        disable: true,
                    },
                    operations: {
                        disable: false,
                        label: "操作",
                        items: [{
                            label: "查看",
                            type: "default",
                            size: 'mini',
                            click: (index, row) => {
                                this.$_goToDetails(row);
                            },
                        }, ],
                    },
                    head: [{
                            prop: "occure_at",
                            label: "告警时间",
                            width: "200",
                        },
                        {
                            prop: "site_name",
                            label: "告警站点",
                            width: "",
                        },
                        {
                            prop: "host",
                            label: "告警对象",
                            width: "200",
                        },
                        {
                            prop: "severity",
                            label: "告警级别",
                            width: "100",
                        },
                        {
                            prop: "worksheet_status",
                            label: "工单状态",
                            width: "100",
                        },
                        {
                            prop: "content",
                            label: "告警内容",
                            width: ""
                        },
                    ],
                    data: [],
                },
                dialog: {
                    siteName: {
                        visible: false,
                        title: "站点详情",
                        style: {
                            showConfirm: false,
                            showCancel: false,
                        },
                        methods: {
                            open: (row) => {
                                this.dialog.siteName.data.id = row.site_id;
                                this.$_getSite(row.site_id);
                                this.dialog.siteName.visible = true;
                            },
                        },
                        data: {
                            id: "",
                        },
                    },
                    warning: {
                        visible: false,
                        title: "告警内容",
                        style: {
                            showConfirm: false,
                            showCancel: false,
                        },
                        methods: {
                            open: (item) => {
                                this.dialog.warning.data.content = item.content;
                                this.dialog.warning.visible = true;
                            },
                        },
                        data: {
                            content: "",
                        },
                    },
                    create: {
                        visible: false,
                        title: "提示信息",
                        style: {
                            showConfirm: true,
                        },
                        methods: {
                            open: (item) => {
                                this.dialog.create.data.row = item
                                this.dialog.create.visible = true;
                            },
                            confirm: () => {
                                let row = this.dialog.create.data.row
                                this.$router.push({
                                    name: 'user-new-workList',
                                    query: {
                                        alert_id: row.alert_id,
                                        site_id: row.site_id,
                                    }
                                });
                            }
                        },
                        data: {
                            row: {},
                        },
                    }
                },
            }
        },
        mounted() {
            this.$_getTableList();
        },
        methods: {
            $_getTableList: async function () {
                this.tableOption.loading = true;
                let params = {
                    query: this.searchParmas,
                }
                let data = await this.$api.userPendWarning.getList.getPendList.call(this, params);
                if (data !== false) {
                    this.tableOption.data = data;
                }
                this.tableOption.loading = false;
            },
            $_getSite: async function () {
                let params = {
                    site_id: this.dialog.siteName.data.id
                }
                let data = await this.$api.userPendWarning.getList.getSite.call(this, params);
                if (data !== false) {
                    this.site = data[0];
                }
            },
            $_creatNewWork: async function (row) {
                let params = {
                    alert_id: row.alert_id
                }
                let data = await this.$api.userPendWarning.getList.creatNewWork.call(this, params);
                if (data !== false) {
                    this.dialog.create.methods.open(row)
                } else {
                    this.$router.push({
                        name: 'user-new-workList',
                        query: {
                            alert_id: row.alert_id,
                            site_id: row.site_id,
                        }
                    });
                }
            },
            $_handleTime(time) {
                let origindate = Date.parse(time);
                let date = new Date(origindate + 8 * 60 * 60 * 1000)
                let Y = date.getFullYear() + '-';
                let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                let D = date.getDate() + ' ';
                let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
                let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
                let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
                return Y + M + D + h + m + s
                // return date;
            }
        },
        watch: {
            pager: {
                deep: true,
                handler: function () {
                    this.$_getTableList();
                },
            },
        }
    }
</script>

<style lang="less" scoped>
    .pend-warning {
        width: 100%;

        .deal-item {
            cursor: pointer;
            color: #1890FF;
        }

        .content {
            min-width: 400px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .site-content {
            display: inline-flex;
            width: 100%;
            margin-bottom: 10px;

            .site-content-item {
                flex: 1;

                label {
                    color: #b3b3b3
                }

                ;

                span {
                    color: #777
                }
            }
        }
    }
</style>